module.exports = __webpack_public_path__ + "static/media/storeBanner1.337a99ec.png";